import TextInput from '../../../Shared/TextInput/TextInput';
import React from 'react';
import {Container, Row, Button, ButtonGroup, Input, InputGroup, Label, FormGroup} from 'reactstrap';
import {DATA_TRANSFER_ENUM, planSelectionRadioEnums} from '../IdfSaleEnums';
import RadioInput from '../../../Shared/RadioInput/RadioInput';
import Terms from '../Constans/Terms';
import Checkbox from 'app/Components/Shared/CheckBox/Checkbox';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { TermsDataPartThree } from '../Constans/TermsData';
import Service from '../Constans/Service';

function ServicesFormPopUp(props) {
  const { idfStore, auth } = props.props;

  // Check if idfStore is provided, if not, use props directly
  const userDetails = idfStore ? idfStore.userDetails : props.userDetails || {};
  const selectedAddress = idfStore ? idfStore.selectedAddress : props.selectedAddress || {};
  const contactNumber = idfStore.lineType === planSelectionRadioEnums.INTRESTED_IN_NEW_LINE.value ?"0"+ idfStore.userDetails.new_line_code : idfStore.lineNumber;

  const { first_name: firstName, last_name: lastName, id_number: idNumber } = userDetails;
  const { cityName, streetName, home, zipCode } = selectedAddress;

  return (
    <div className='services-and-joining-form-pop-up'>
      <div className='popup-title'>
        <Row className='idf-title-bold justify-content-center d-flex'>טופס גישה לשירותים</Row>
        <Row className='idf-line justify-content-center d-flex mb-3'></Row>
        <div className='idf-sub-title-bold justify-content-center d-flex' style={{ width: '85%' }}>
          {' '}
          מלאו את הפרטים ואשרו את הטופס{' '}
        </div>
      </div>
      <div className='info-disabled-inputs-container'>
        <TextInput
          onChange={() => { }}
          className='mb-2'
          value={`${firstName || ''} ${lastName || ''}`}
          placeholder='שם מלא'
          required='required'
          disabled={true}></TextInput>
        <TextInput
          onChange={() => { }}
          className='mb-2'
          value={idNumber || ''}
          placeholder='תעודת זהות'
          required='required'
          disabled={true}></TextInput>
        <TextInput
          onChange={() => { }}
          className='mb-2'
          value={cityName || ''}
          placeholder='ישוב'
          required='required'
          disabled={true}></TextInput>
        <TextInput
          onChange={() => { }}
          className='mb-2'
          value={streetName || ''}
          placeholder='שם הרחוב'
          required='required'
          disabled={true}></TextInput>
        <TextInput
          onChange={() => { }}
          className='mb-2'
          value={home || ''}
          placeholder='מספר הבית'
          required='required'
          disabled={true}></TextInput>
        <TextInput
          onChange={() => { }}
          className='mb-2'
          value={zipCode || ''}
          placeholder='מיקוד'
          required='required'
          disabled={true}></TextInput>
        <TextInput
          onChange={() => { }}
          className='mb-2'
          value={contactNumber || ''}
          placeholder='מספר טלפון'
          required='required'
          disabled={true}></TextInput>
      </div>
      <Service setIsShowPopUp={props.setIsShowPopUp}></Service>
    </div>
  );
}

export default ServicesFormPopUp;
